import React, { Component } from 'react';
import { Button, Row, Col, Alert, Label, Input, FormGroup } from 'reactstrap';
import ConfirmModal from '@components/ConfirmModal/ConfirmModal';
import axiosInstance from '@src/axios-instance';
import isAllowed from '@src/auth';
import Auth from '@src/components/Elements/Auth/Auth';
import connect from 'react-redux/es/connect/connect';

class Remarks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultRemarks: false,
      cover_letter: false,
      sample_quote: false,
      confirmModalActive: false,
      confirmSampleQuoteActive: false,
      confirmBody: 'Please confirm to delete this condo questionnaire.',
      confirmLabel: 'Yes, delete this cover_letter',
      type: 'cover_letter',
      customSampleQuote: props.entity.custom_sample_quote,
      sampleQuoteRegionId: props.entity.sample_quote_region_id,
      successRegionUpdate: false,
      loading: false
    };
    this.toggleInput = this.toggleInput.bind(this);
  }

  openFilePicker = type => {
    if (type === 'cover_letter') {
      this.coverLetterUpload.click();
    } else if (type === 'sample_quote') {
      this.sampleQuoteUpload.click();
    }
  };

  toggleInput(input) {
    if (isAllowed({ action: 'Associations::editDocuments' })) {
      const current = this.state[input];
      this.setState({
        [input]: !current
      });
      if (!current) {
        setTimeout(() => {
          document.getElementsByClassName(input)[0].focus();
        }, 200);
      }
    }
  }

  toggle = (modalType, type) => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType],
      type: type,
      confirmBody:
        type === 'cover_letter'
          ? 'Please confirm to delete this condo questionnaire.'
          : 'Please confirm to delete this sample quote.',
      confirmLabel:
        type === 'cover_letter'
          ? 'Yes, delete this condo questionnaire'
          : 'Yes, delete this sample quote'
    }));
  };

  onFileSelect = (e, type) => {
    if (
      this.coverLetterUpload.files.length > 0 ||
      this.sampleQuoteUpload.files.length > 0
    ) {
      const formData = new FormData();
      if (type === 'cover_letter') {
        formData.append('cover_letter', this.coverLetterUpload.files[0]);
      } else if (type === 'sample_quote') {
        formData.append('sample_quote', this.sampleQuoteUpload.files[0]);
        formData.append('custom_sample_quote', this.state.customSampleQuote);
      }

      axiosInstance()
        .post(
          `/associations/upload-attachments/${this.props.entityId}.json`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then(response => {
          this.setState({
            [type]:
              type === 'cover_letter'
                ? 'Condo Questionnaire document has been updated.'
                : 'Sample Quote document has been updated.'
          });
          this.props.associationSuccess({ viewItem: response.data });
        })
        .catch(err => {
          alert('Error');
        });
      if (type === 'cover_letter') {
        this.coverLetterUpload.value = '';
      } else if (type === 'sample_quote') {
        this.sampleQuoteUpload.value = '';
      }
    }
  };

  onFileRemove = (e, type) => {
    axiosInstance()
      .get(
        `/associations/remove-attachment/${this.props.entityId}/${type}.json`
      )
      .then(response => {
        this.setState({
          confirmModalActive: false,
          [type]:
            type === 'cover_letter'
              ? 'Condo Questionnaire document has been removed.'
              : 'Sample Quote document has been removed.'
        });
        this.props.associationSuccess({ viewItem: response.data });
      })
      .catch(err => {});
  };

  saveRegion = () => {
    this.setState(
      {
        loading: true
      },
      () => {
        axiosInstance()
          .post(`/associations/save-region/${this.props.entityId}.json`, {
            sample_quote_region_id: this.state.sampleQuoteRegionId
          })
          .then(response => {
            this.setState({
              loading: false,
              successRegionUpdate: true
            });
          })
          .catch(err => {});
      }
    );
  };

  onToggleSampleQuote = () => {
    axiosInstance()
      .get(`/associations/toggle-custom-quote/${this.props.entityId}.json`)
      .then(response => {
        this.setState({
          customSampleQuote: response.data.custom_sample_quote,
          sampleQuoteRegionId: response.data.sample_quote_region_id,
          confirmSampleQuoteActive: false
        });
      })
      .catch(err => {});
  };

  render = () => {
    const { entity, permissions } = this.props;

    const allowEditDocument =
      permissions['Associations::editDocuments'] === undefined ||
      permissions['Associations::editDocuments'] === 1;
    return (
      <React.Fragment>
        <Row>
          <Col>
            <h3>
              Condo Questionnaire
              <Auth action={'Associations::editDocuments'}>
                <Button
                  color={'secondary'}
                  className={'float-right'}
                  size={'sm'}
                  onClick={() => this.openFilePicker('cover_letter')}
                >
                  Upload New
                </Button>
                <input
                  ref={ref => (this.coverLetterUpload = ref)}
                  type={'file'}
                  className={'d-none'}
                  onChange={e => this.onFileSelect(e, 'cover_letter')}
                  accept={'.pdf'}
                />
              </Auth>
            </h3>
            <p>Supported file formats: PDF</p>
            <Row>
              <Col xs={9}>
                {this.state.cover_letter !== false && (
                  <Alert color="success">{this.state.cover_letter}</Alert>
                )}
                <div className={'border-bottom text-center'}>
                  {entity.cover_letter.length === 0 ? (
                    'NO CONDO QUESTIONNAIRE'
                  ) : (
                    <a href={entity.cover_letter} target={'_blank'}>
                      {
                        entity.cover_letter
                          .substring(entity.cover_letter.lastIndexOf('/') + 1)
                          .split('?')[0]
                      }
                    </a>
                  )}
                </div>
              </Col>
              <Col xs={3}>
                <Auth action={'Associations::editDocuments'}>
                  {entity.cover_letter.length !== 0 && (
                    <Button
                      color={'danger'}
                      onClick={() =>
                        this.toggle('confirmModalActive', 'cover_letter')
                      }
                    >
                      Remove
                    </Button>
                  )}
                </Auth>
              </Col>
            </Row>
          </Col>
        </Row>

        <hr className={'my-5'} />

        <Row>
          <Col>
            <h3>Sample Quote</h3>
            <div>
              <FormGroup check className={'pb-2'}>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={this.state.customSampleQuote === 1}
                    disabled={!allowEditDocument}
                    onClick={
                      allowEditDocument
                        ? () => this.toggle('confirmSampleQuoteActive')
                        : null
                    }
                  />{' '}
                  Custom File
                </Label>
              </FormGroup>
              {this.state.customSampleQuote === 1 ? (
                <Row>
                  {allowEditDocument && (
                    <Col xs={'6'}>
                      <Button
                        color={'secondary'}
                        size={'sm'}
                        onClick={() => this.openFilePicker('sample_quote')}
                      >
                        Upload New
                      </Button>
                      <p>Supported file formats: PDF</p>
                      <input
                        ref={ref => (this.sampleQuoteUpload = ref)}
                        type={'file'}
                        className={'d-none'}
                        onChange={e => this.onFileSelect(e, 'sample_quote')}
                        accept={'.pdf'}
                      />
                    </Col>
                  )}

                  <Col xs={9}>
                    <p>
                      <strong>Preview</strong>
                    </p>
                    {this.state.sample_quote !== false && (
                      <Alert color="success">{this.state.sample_quote}</Alert>
                    )}
                    <div className={'border-bottom text-center'}>
                      {entity.sample_quote.length === 0 ? (
                        'NO SAMPLE QUOTE'
                      ) : (
                        <a href={entity.sample_quote}>
                          {
                            entity.sample_quote
                              .substring(
                                entity.sample_quote.lastIndexOf('/') + 1
                              )
                              .split('?')[0]
                          }
                        </a>
                      )}
                    </div>
                  </Col>
                  {allowEditDocument && (
                    <Col xs={3} className={'pt-4'}>
                      {entity.sample_quote.length !== 0 && (
                        <Button
                          color={'danger'}
                          onClick={() =>
                            this.toggle('confirmModalActive', 'sample_quote')
                          }
                        >
                          Remove
                        </Button>
                      )}
                    </Col>
                  )}
                </Row>
              ) : (
                <Row>
                  {this.state.successRegionUpdate && (
                    <Col xs={12}>
                      <Alert color={'success'}>
                        Sample Quote Region has been updated.
                      </Alert>
                    </Col>
                  )}
                  <Col xs={4}>
                    <div className={'form-group mb-1'}>
                      <span className={'font-weight-bold'}>
                        Pick a Region (Required)
                      </span>
                      <select
                        className={'form-control'}
                        disabled={!allowEditDocument}
                        value={this.state.sampleQuoteRegionId}
                        onChange={e =>
                          this.setState({
                            sampleQuoteRegionId: e.currentTarget.value
                          })
                        }
                      >
                        {this.state.sampleQuoteRegionId === null && (
                          <option value="" disabled selected>
                            -- Unselected --
                          </option>
                        )}
                        {this.props.entity.sample_quote_regions.map(item => {
                          return <option value={item.id}>{item.name}</option>;
                        })}
                      </select>
                    </div>
                  </Col>
                  {allowEditDocument && (
                    <Col xs={3} className={'pt-4'}>
                      {this.state.loading ? (
                        <Button color={'secondary'}>Saving</Button>
                      ) : (
                        <Button onClick={this.saveRegion} color={'secondary'}>
                          Update
                        </Button>
                      )}
                    </Col>
                  )}
                </Row>
              )}
            </div>
          </Col>
        </Row>

        <ConfirmModal
          isActive={this.state.confirmSampleQuoteActive}
          toggle={() => this.toggle('confirmSampleQuoteActive')}
          body={
            'Please confirm to update the Sample Quote preference for this Association.'
          }
          confirmLabel={'Yes, confirm to update the preference.'}
          confirmAction={this.onToggleSampleQuote}
        />

        <ConfirmModal
          isActive={this.state.confirmModalActive}
          toggle={() => this.toggle('confirmModalActive')}
          body={this.state.confirmBody}
          confirmLabel={this.state.confirmLabel}
          confirmAction={e => this.onFileRemove(e, this.state.type)}
        />
      </React.Fragment>
    );
  };
}

const mapStateToProps = state => {
  return {
    permissions: state.auth.permissions
  };
};
export default connect(
  mapStateToProps,
  null
)(Remarks);
